import { i18n } from "../src/plugins/i18n";

const content = {
  tabs: [
    {
      value: "ActiveAlerts",
      label: i18n.t("views.PowerdataAlerts.tabs.activeAlerts.label"),
    },
    {
      value: "ManageAlerts",
      label: i18n.t("views.PowerdataAlerts.tabs.manageAlerts.label"),
    },
  ],
  DeviceType: ["", "ROG1PHASE", "ROG3PHASE"],
  TriggerField: [
    {
      label: "Alarm",
      value: "Alarm",
    },
    {
      label: "Max Current PH1",
      value: "Current0Max",
    },
    {
      label: "Med Current PH1",
      value: "Current0Med",
    },
    {
      label: "Max Current PH2",
      value: "Current1Max",
    },
    {
      label: "Med Current PH2",
      value: "Current1Med",
    },
    {
      label: "Max Current PH3",
      value: "Current2Max",
    },
    {
      label: "Med Current PH3",
      value: "Current2Med",
    },
    {
      label: "Max Temperature",
      value: "TemperatureMax",
    },
    {
      label: "Med Temperature",
      value: "TemperatureMed",
    },
    {
      label: "Imbalance",
      value: "Imbalance",
    },
    {
      label: "Total Power",
      value: "TotalPower",
    },
  ],
  TriggerOperator: ["<", ">"],
  alerts_table: [
    {
      align: "start",
      text: i18n.t("views.PowerdataAlerts.tables.alerts.columns.alertId.text"),
      value: "AlertID",
      sortable: true,
      of_type: "text",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.alerts.columns.deviceId.text"),
      value: "DeviceID",
      of_type: "link",
      identifier: "DeviceID",
      url: "/asset/",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.alerts.columns.deviceType.text"),
      value: "DeviceType",
      of_type: "text",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.alerts.columns.triggerField.text"),
      value: "TriggerField",
      of_type: "lookup",
      config: "PowerDataDeviceType",
    },

    {
      text: i18n.t("views.PowerdataAlerts.tables.alerts.columns.triggerValue.text"),
      value: "TriggerValue",
      of_type: "text",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.alerts.columns.triggerOperator.text"),
      value: "TriggerOperator",
      of_type: "text",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.alerts.columns.moreActions.text"),
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["ManageRecipients", "EditDetails", "Delete"],
      labels: i18n.t("views.PowerdataAlerts.tables.alerts.columns.moreActions.labels"),
    },
  ],
  active_alerts_table: [
    {
      align: "start",
      text: i18n.t("views.PowerdataAlerts.tables.activeAlerts.columns.alertId.text"),
      value: "ActiveAlertID",
      sortable: true,
      of_type: "text",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.activeAlerts.columns.deviceId.text"),
      value: "DeviceID",
      of_type: "link",
      identifier: "DeviceID",
      url: "/asset/",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.activeAlerts.columns.fullName.text"),
      value: "FullName",
      of_type: "text",
      identifier: "AlertID",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.activeAlerts.columns.deviceType.text"),
      value: "DeviceType",
      of_type: "text",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.activeAlerts.columns.triggerField.text"),
      value: "TriggerField",
      of_type: "lookup",
      config: "PowerDataDeviceType",
    },

    {
      text: i18n.t("views.PowerdataAlerts.tables.activeAlerts.columns.triggerValue.text"),
      value: "TriggerValue",
      of_type: "text",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.activeAlerts.columns.actualValue.text"),
      value: "ActualValue",
      of_type: "text",
    },
    {
      text: i18n.t("views.PowerdataAlerts.tables.activeAlerts.columns.triggerDate.text"),
      value: "TriggerDate",
      of_type: "date",
    },
  ],
};

export { content };
